import React from "react";
import { FlipHorizontal2, FlipVertical2 } from "lucide-react";
import { ShapeControlProps } from "./types";
import { ShapeControlButton } from "./ShapeControlButton";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";

export const ShapeControlFlipHorizontal: React.FC<ShapeControlProps> = ({
  shape,
  onUpdate,
}) => {
  const { shortcuts } = useEditorShortcuts();
  const handleFlip = () => {
    const newScaleX = (shape.scaleX || 1) * -1;
    onUpdate({
      scaleX: newScaleX,
      x: shape.x + (newScaleX < 0 ? shape.width : -shape.width)
    });
  };
  return (
    <ShapeControlButton
      onClick={handleFlip}
      title="Flip Horizontal"
      icon={FlipHorizontal2}
      shortcut={shortcuts.shapeSelection.flipHorizontal}
    />
  );
};

export const ShapeControlFlipVertical: React.FC<ShapeControlProps> = ({
  shape,
  onUpdate,
}) => {
  const { shortcuts } = useEditorShortcuts();
  const handleFlip = () => {
    const newScaleY = (shape.scaleY || 1) * -1;
    onUpdate({
      scaleY: newScaleY,
      y: shape.y + (newScaleY < 0 ? shape.height : -shape.height)
    });
  };
  return (
    <ShapeControlButton
      onClick={handleFlip}
      title="Flip Vertical"
      icon={FlipVertical2}
      shortcut={shortcuts.shapeSelection.flipVertical}
    />
  );
};
